import { Box } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';

interface PokemonSpriteProps {
  pokemonId: number;
  pokemonName: string;
  size?: number;
  pictureUrl?: string;
}

function PokemonSprite({ pokemonId, pokemonName, pictureUrl, size = 48 }: PokemonSpriteProps) {
  const defaultSpriteUrl = useMemo(
    () => `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${pokemonId}.png`,
    [pokemonId],
  );
  const artworkUrl = useMemo(
    () => `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${pokemonId}.png`,
    [pokemonId],
  );
  const [currentSrc, setCurrentSrc] = useState(pictureUrl || defaultSpriteUrl);

  useEffect(() => {
    // 選択中のポケモンや画像URLが変わったら初期表示を更新する
    setCurrentSrc(pictureUrl || defaultSpriteUrl);
  }, [pictureUrl, defaultSpriteUrl]);

  const handleError = () => {
    // 画像が読み込めない場合は pictureUrl → default → artwork の順でフォールバックする
    if (pictureUrl && currentSrc === pictureUrl) {
      setCurrentSrc(defaultSpriteUrl);
      return;
    }
    if (currentSrc === defaultSpriteUrl && currentSrc !== artworkUrl) {
      setCurrentSrc(artworkUrl);
    }
  };

  return (
    <Box
      component="img"
      src={currentSrc}
      alt={pokemonName}
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
      }}
      onError={handleError}
    />
  );
}

export default PokemonSprite;
